import { useQuery } from "react-query";

import { merchantGeneralTabService } from "services";

type useGetMerchantLogoQueryProps = {
	merchantId: string;
	onSuccess?: Function;
};

const useGetMerchantLogoQuery = ({
	merchantId,
	onSuccess,
}: useGetMerchantLogoQueryProps) => {
	const queryResult = useQuery(
		["getMerchantLogoQuery", merchantId],
		() => merchantGeneralTabService.getMerchantLogo(merchantId),
		{
			onSuccess: data => onSuccess?.(data),
			enabled: !!merchantId,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetMerchantLogoQuery;
